export const formatExtensionMessage = (extensionsTimes: {
  first_treatment: number;
  pain_management: number;
  larger_surface_area: number;
  shaving_assistance: number;
}) => {
  const labelMap: Record<keyof typeof extensionsTimes, string> = {
    first_treatment: 'first treatment',
    pain_management: 'pain management',
    larger_surface_area: 'larger surface area',
    shaving_assistance: 'shaving assistance',
  };

  const included = Object.entries(extensionsTimes)
    .filter(([, value]) => value > 0)
    .map(([key]) => labelMap[key as keyof typeof extensionsTimes]);

  if (included.length === 0) return null;

  const separator = included.length > 1 ? ' - ' : '';
  const formatted = included.join(separator);

  return formatted;
};
